import { render, staticRenderFns } from "./PageThree.vue?vue&type=template&id=6c684b96&scoped=true"
import script from "./PageThree.vue?vue&type=script&lang=js"
export * from "./PageThree.vue?vue&type=script&lang=js"
import style0 from "./PageThree.vue?vue&type=style&index=0&id=6c684b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c684b96",
  null
  
)

export default component.exports